import { MDBDropdown, MDBDropdownItem, MDBDropdownMenu, MDBDropdownToggle } from 'mdb-react-ui-kit';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { memoizedGetAuthUser, purgeAuth } from '../../Store/Reducer/authReducer';
import { useNavigate, useParams } from 'react-router-dom';
import { useContext } from 'react';
import CmsContext from '../../Context/CmsContext';
import Breadcrumb from '../../Components/BreadCrumb/BreadCrumb';

const AdminHeader = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const authUser = useSelector(memoizedGetAuthUser);
    const cmsContext = useContext(CmsContext);

    const gotoHomepage = () => {

    }
    const onChangePassword = () => {

    }
    const handleLogout = (e) => {
        e.preventDefault();

        if(!authUser) return;

        dispatch(purgeAuth());

        navigate('/login');
    }

    return (
        <div className="top-header d-flex align-items-center">
            <div className='d-flex align-items-end'>
                <img src="/img/logo/uws-logo.jpg" className='logo-img me-4' />
                <Breadcrumb breadcrumb={cmsContext.breadcrumb} />
            </div>
            <div className='flex-fluid d-flex justify-content-end align-items-center'>
                <div>
                    <span style={{color: 'red'}}>Welcome </span>
                    <span className='ms-2' style={{color: '#00c800'}}>{authUser?.username}</span>
                </div>
                <MDBDropdown>
                    <MDBDropdownToggle className='bg-transparent authuser-action' style={{boxShadow:'none', color:'#555'}}>
                        <img src="/img/icons/png/default_user.png" className='circle-avatar-50' alt=''/>
                    </MDBDropdownToggle>
                    <MDBDropdownMenu>
                        <MDBDropdownItem link onClick={gotoHomepage}>Go to Homepage</MDBDropdownItem>
                        <MDBDropdownItem link onClick={onChangePassword}>Change Password</MDBDropdownItem>
                        <MDBDropdownItem link onClick={handleLogout}>Log Out</MDBDropdownItem>
                    </MDBDropdownMenu>
                </MDBDropdown>
            </div>
        </div>
    )
}

export default AdminHeader;